import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {PRINTER} from "../../util/RouteConstants";
import PrinterDeviceOverviewContextProvider from "./context/PrinterDeviceOverviewContext";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class PrinterDevicePage extends Component {
    render() {

        const getPrinterRoutes = () => {
            return PRINTER;
        }

        return (
            <Column>
                <PrinterDeviceOverviewContextProvider>
                    <TabLayout routes={getPrinterRoutes()} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={getPrinterRoutes()}/>
                </PrinterDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default PrinterDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/PrinterDevicePage.js